import axios from 'axios';

export const env = 3; // 1, 2: Staging, 3: Production, else: Local
export const getURL = (env) => {
  if (env === 1) return 'http://65.1.214.43:3302/api';
  if (env === 2) return 'https://api.palminfotech.com/3303/api/';
  if (env === 3) return 'https://api.okavya.com/api/';
  else return 'http://localhost:3302/api/';
};

const instance = axios.create({
  baseURL: getURL(env)
});

instance.interceptors.request.use(
  (request) => {
    const accessToken = window.localStorage.getItem('accessToken');
    request.headers = {
      Authorization: `Bearer ${accessToken}`,
      WebAdmin: true,
      'Content-Type': request.headers['Content-Type'] || 'application/json'
    };
    return request;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('Error response:', error.response.data.message);

      if (error.response.status === 401 && !window.location.href.includes('/login')) {
        localStorage.setItem('logoutFlag', 'true');
        attachLogoutListener();
      }
    } else {
      console.error('Error details:', error.message);
    }

    return Promise.reject({
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
  }
);

// Function to handle logout
const handleLogout = () => {
  if (localStorage.getItem('logoutFlag') === 'true') {
    localStorage.clear();
    localStorage.removeItem('logoutFlag');
    window.location.href = '/login';
  }
};

// Function to attach event listeners dynamically
const attachLogoutListener = () => {
  ['click', 'keydown', 'mousemove', 'touchstart'].forEach((event) => {
    document.addEventListener(event, handleLogout, { once: true });
  });
};

export default instance;
